import React from "react";
import { ColumnProps } from "@wit/mpesa-ui-components/lib/components/table/table.component";
import i18next from "i18next";

export const IdentityDocUtils = {
  getTableColumns: (): ColumnProps[] => {
    return [
      {
        ratio: 2 / 12,
        label: i18next.t("pages.manageIdentity.table.documentId"),
        formKey: "documentId",
        isEditable: false,
        changeFunction: (content: string) => content || "-",
      },
      {
        ratio: 2 / 12,
        label: i18next.t("pages.manageIdentity.table.labelEn"),
        formKey: "en",
        isEditable: false,
        changeFunction: (content: string) => content || "-",
      },
      {
        ratio: 2 / 12,
        label: i18next.t("pages.manageIdentity.table.labelFr"),
        formKey: "fr",
        isEditable: false,
        changeFunction: (content: string) => content || "-",
      },
      {
        ratio: 2 / 12,
        label: i18next.t("pages.manageIdentity.table.documentStandard"),
        formKey: "documentStandard",
        isEditable: false,
        changeFunction: (content: string) => {
          const translated = i18next.t(`commons.identityType.${content}`);
          return translated === `commons.identityType.${content}` ? content || "-" : translated;
        },
      },
      {
        ratio: 1.5 / 12,
        label: i18next.t("pages.manageIdentity.table.status"),
        formKey: "status",
        isEditable: false,
        changeFunction: (content: string) => {
          const translated = i18next.t(`commons.identityStatus.${content}`);
          return translated === `commons.identityStatus.${content}` ? content || "-" : translated;
        },
      },
      {
        ratio: 1.5 / 12,
        label: i18next.t("pages.manageIdentity.table.captureBackSide"),
        formKey: "captureBackSide",
        isEditable: false,
        changeFunction: (content: string) => {
          const translated = i18next.t(`commons.captureStatusType.${content}`);
          return translated === `commons.captureStatusType.${content}` ? content || "-" : translated;
        },
      },
    ];
  },
};
